module.exports = __webpack_public_path__ + "kacirek11-22-prany.jpg?3ac4536b8ebf9bf31a7f5b3d02180acb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/kacirek11-22-prany.jpg
// module id = 81
// module chunks = 0